// extracted by mini-css-extract-plugin
export default {"section":"CollapsibleSection_section__5tm-t"};